<template>
  <div class="modal fade" :class="{'is-open': open}">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <a class="close" @click="$emit('close')"><i class="icon-close"></i></a>
          <h3 v-if="open" class="modal-title">列印{{ sendTypeName }}專函</h3>
        </div>
        <div v-if="open" class="modal-body send-modal-body" :class="{'section-loading': sendLoading}">
          <ol class="pl-3 sub-ol">
            <li>拜訪前 <br/>
              <span style="color:red;font-weight: bold">(1)開啟檔案密碼為您的「身分證字號」。(英文字母大寫)</span><br>
              <span style="color:red;font-weight: bold">(2)服務聯繫專函僅提供正文，不包含契約資料一覽表。</span>
            </li>
            <li>拜訪中
              <ol class="p-0">
                <li>保戶服務聯繫專函(分親送/郵寄版)，通知保戶相關權益，可留給保戶作為參考。</li>
                <li>建議您拜訪前同時攜帶「電子單據/行動服務申請書(業務員代送專用)」，便利保戶同時開通電子單據與行動服務。</li>
              </ol>
            </li>
            <li>完成拜訪後 <br />
              您只要完成實質接觸項目，都計入績效認定。
            </li>
          </ol>
          <div>如同仁對於活動辦法有任何問題，請洽總公司<span style="color:red;font-weight: bold">業務部業務企劃科(02)27551399#{{ this.$store.state.serviceLine }}</span>。<br />
          <span class="text-green">(注意：列印PDF時，請於列印設定之「頁面處理」/「頁面縮放」選擇「無」之後再列印)</span></div>
          <div class="action text-right mt-2">
            <a @click.prevent="submit()" class="btn btn-primary">
              列印{{ sendTypeName }}專函
            </a>
          </div>
        </div>
        <form v-show="false" name='form_A' :action="postUrl" method='post' target="_blank" accept-charset="big5" onsubmit="document.charset = 'big5'">
          <span>聯繫單樣式 :  </span>
          <input name='PRINT_SE' :value="sendtype"><br>
          <span>資料(多筆) :  </span>
          <input name='FORMDATA' :value="formData"><br>
          <span>業務員ID :  </span>
          <input name='AGID' :value="agid"><br>
          <button type="submit" id="sendSubmit2">點擊送出</button>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {commonMixin} from '@/mixins/common'
import { getChangePrint_all, getCustIAA, showChangePDF } from "@/service";

export default {
  name: 'SendAllModal',
  mixins: [commonMixin],
  props: {
    open: {
      type: Boolean,
      default: false
    },
    sendtype: {
        type: String,
        default: ''
    },
    ceapcnoList: {
      type: Array,
      default: () => {
        return [];
      }
    },
    visit_noList: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  computed : {
    ...mapGetters([ 'UserInfo' ]),
    isBox() {
     //判斷是否為box
     return this.UserInfo.userType === 'box'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.initSend() // 初始化
      }
    },
  },
  data() {
    return {
      sendLoading: false,
      formData: {
        div_info: {},
        visit_main: [],
        visit_sub: [],
      },
      postUrl: '',
      nowDate: {
        nowYear: '',
        nowMonth: '',
        nowDay: '',
      },
      sendTypeName: '',
      agid: '',
      custids:[],
      visitnos:[],
      sendUrl: "crms/ProReport/servlet/servlets.ServiceContactForm" //報表路徑
    }
  },
  methods: {
    initSend () { // 初始化
      // this.sendLoading = true
      this.registerHanlink();
      if(this.sendtype=='4'){
        this.sendTypeName = '親送'
      }else{
         this.sendTypeName = '郵寄'
      }
      this.custids = this.ceapcnoList
      this.visitnos = this.visit_noList
    },
    numFormat (num = 0, unit = '') { // 組合保額 and 保額單位
      let number = Number(num) 
      if (number >= 10000) {
        number = ( number / 10000 ).toFixed(1) + ''
        number = number.replace(/\.0/, '') // (四捨五入到小數點後1位，小數為0則省略，例：3.5萬元、2萬元)
        return number + '萬' + unit
      } else {
        return number + '' + unit
      }
    },
    dateFormat (val) {  // 轉換為民國
      if(val) {
        let dataAry = val.split('-')
        dataAry[0] = dataAry[0] * 1 - 1911 + ''
        return dataAry.join('-')
      } else {
        return ''
      }
    },
    async submit() {
      this.sendLoading = true;
      let newWindow;
      if (!this.isBox) {
        newWindow = window.open("/crm/assets/common/ajax-loader.gif");
      }
      const res = await getChangePrint_all(
        this.$store.state.userInfo.id,
        this.custids,
        this.visitnos,
        this.$store.state.userInfo.divNo
      );
      this.sendLoading = false;
      if (!res.header || res.header.status !== "200") {
        return;
      }
      const printData = res.body.print_data || [];
      this.sendLoading = true;
      await Promise.all(printData.map((item) => {
        return getCustIAA(
          this.$store.state.userInfo.id,
          item.ceapcno,
          "queryAPI"
        ).then((result) => {
          if (
            result.header &&
            result.header.status === "200" &&
            result.body &&
            result.body.detail
          ) {
            const detail = result.body.detail;
            item.cs_mobile = detail.mobl_no || "";
            item.cs_tel =
              (detail.htel_area || "") +
              (detail.htel_num || "") +
              (detail.htel_ext ? "#" + detail.htel_ext : "");
          } else {
            item.cs_mobile = "";
            item.cs_tel = "";
          }
        });
      }));
      this.sendLoading = false;

      this.formData = JSON.stringify(printData);
      this.agid = this.$store.state.userInfo.id;
      
      const pdfResult = await showChangePDF(this.$store.state.userInfo.id, {
        PRINT_SE: this.sendtype || "",
        AGID: this.agid || "",
        FORMDATA: this.formData || ""
      });

      if (this.isBox) {
        this.boxSendBase64PdfData(new Uint8Array(pdfResult.file));
      } else {        
        const file = new Blob([new Uint8Array(pdfResult.file)], {
          type: "application/pdf"
        });
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(file, "post.pdf");
        } else {
          newWindow.location = URL.createObjectURL(file);
        }
      }

      this.$emit("close");
    }
  },
  mounted () {
    //  post網址
    // 'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    let href = window.location.href
    if(href.includes('://mycrm')){  // 正式環境
      this.postUrl = 'https://w3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    } else if (href.includes('://smycrm')) {  // 平測環境
      this.postUrl = 'https://sw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    } else {  // local & 測試環境
      this.postUrl = 'https://tw3.cathaylife.com.tw/crms/ProReport/servlet/servlets.ServiceContactForm'
    }

    //  紀錄當前系統時間
    const nowD = new Date()
    this.nowDate.nowYear = nowD.getFullYear() - 1911 + ''
    this.nowDate.nowMonth = nowD.getMonth() + 1 + ''
    this.nowDate.nowDay = nowD.getDate() + ''
    if(this.nowDate.nowMonth.length == 1) {this.nowDate.nowMonth = '0' + this.nowDate.nowMonth}
    if(this.nowDate.nowDay.length == 1) {this.nowDate.nowDay = '0' + this.nowDate.nowDay}
  },
}
</script>
